<template>
    <div class="info-list-wrap">
      <!-- 微信认证组件 -->
      <wxAuth :share="share" :key="$route.query.tagName"></wxAuth>
      <!-- title -->
      <headers :params="hraderP"></headers>
      <!-- 业签 -->
      <van-tabs v-model="active" @click="listSelect">
        <van-tab  v-for="tag in tagList" :title="tag.name" :key="tag.id"></van-tab>
      </van-tabs>
      <!-- 列表 -->
      <van-list :immediate-check=false v-model="loading" loading-text="加载中" :finished="finished" @load="getDataList" v-if="params.total>0" v-cloak>
          <list :params="params"></list>
      </van-list>
      <noResult :noResultData="noResultData" @toListSelf="getListBefore" v-else></noResult>
    </div>
</template>

<script>
import headers from '@/components/headers'
import search from '@/components/search'
import list from '@/components/list'
import noResult from '@/components/noResult'
import { getColumnList, getColumnLabel } from '@/api/news/news'
import wxAuth from '@/components/wxAuth'
export default {
  name: 'news-list',
  components: { search, list, noResult, wxAuth, headers },
  data () {
    return {
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '河姆渡方案馆',
        lefticon: true
      },
      searchParam: {
        type: 'search03',
        placeholder: '',
        callback: 'callback',
        filterType: 'news',
        url: '/hadoop/list.html'
      },
      params: {
        list: [],
        type: 'info',
        label: 'true',
        total: 1
      },
      listQuery: {
        pageNum: 1,
        pageSize: 15
      },
      noResultData: {
        type: 2,
        typeName: '资讯'
      },
      active: 0,
      loading: false,
      finished: false,
      tagList: [],
      currIndex: 0
    }
  },
  mounted () {
    this.getColumnTag()
    this.getListBefore()
  },
  methods: {
    getColumnTag () {
      getColumnLabel().then(res => {
        if (res.data && res.data.code === 200) {
          this.tagList = res.data.data.list.filter(v => {
            return v.name !== '每日三分钟'
          })
          const obj = {
            id: 0,
            name: '全部'
          }
          this.tagList.unshift(obj)
          for (var i = 0; i < this.tagList.length; i++) {
            if (this.tagList[i].name === this.$route.query.tagName) {
              this.active = i
            }
          }
          this.$nextTick(() => {
            if (this.active > 2) {
              document.querySelectorAll('.van-tabs__wrap--scrollable')[0].children[0].scrollLeft = 50 * this.active
            }
          })
        }
      })
    },
    listSelect (index, title) {
      this.active = index
      this.params.list = []
      this.params.total = 1
      this.listQuery = Object.assign({}, this.listQuery, {
        pageNum: 1,
        pageSize: 15
      })
      if (title !== '全部') {
        this.$router.replace(`/news/list.html?tagName=${title}`)
        this.listQuery.tagName = title
      } else {
        this.$router.replace(`/news/list.html`)
        delete this.listQuery.tagName
      }
      this.$set(this.share, 'url', window.location.href.split('#')[0])
      this.getList()
    },
    // 在获取列表数据之前做的判断,isNoResult 用处是  点击随便看看，应该把筛选的条件删除
    getListBefore (isNoResult) {
      this.params.list = []
      this.params.total = 1
      this.listQuery = Object.assign({}, this.listQuery, {
        pageNum: 1,
        pageSize: 15
      })
      if (isNoResult || !this.$route.query.tagName) {
        delete this.listQuery.tagName
        this.active = 0
      } else {
        this.listQuery.tagName = this.$route.query.tagName
      }
      this.getList()
    },
    // list组件需要的方法
    getDataList () {
      if ((this.params.list.length >= this.params.total) && this.params.total !== 0) {
        this.finished = true
      } else {
        this.listQuery.pageNum++
      }
      this.getList()
    },
    // 只是获取数据
    getList () {
      getColumnList(this.listQuery).then(res => {
        this.loading = false
        if (res.data.code === 200) {
          this.params.total = res.data.data.total
          res.data.data.list.forEach(item => {
            this.params.list.push(item)
          })
          if (this.params.list.length >= this.params.total) {
            this.finished = true
          } else {
            this.finished = false
          }
        }
      }).catch(() => {
        this.loading = false
        this.params.total = 0
      })
    }
  }
}
</script>

<style lang="scss">
  .info-list-wrap .van-tabs__line{
    background-color: #1cc0da;
  }
  .diy-tabs {
    overflow: hidden;
    line-height: 44px;
    height: 44px;
    background-color: #fff;
    &-ul {
      overflow-x: auto;
      overflow-y: hidden;
      padding-bottom: 10px;
      display: flex;
      position: relative;
      li {
        flex: 0 0 22%;
        padding: 0 5px;
        text-align: center;
        color: #7d7e80;
        border-bottom: 1px solid #ebedf0;
        &.active {
          transition: all .3s;
          color: #1cc0da;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/news/newsList.vue